export const GOOGLE_API_KEY = 'AIzaSyCoOBoxdyl5-4sHLdNr_Z8a0SrEsSqqu_s';
